export default __webpack_public_path__ + "static/media/footer_telegram.d7953b67.svg";